import { render } from "./HandpickSuggestions.vue?vue&type=template&id=161424b8"
import script from "./HandpickSuggestions.vue?vue&type=script&lang=js"
export * from "./HandpickSuggestions.vue?vue&type=script&lang=js"

import "./HandpickSuggestions.vue?vue&type=style&index=0&id=161424b8&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__